import { render, staticRenderFns } from "./Text705.vue?vue&type=template&id=54647a08&scoped=true&"
import script from "./Text705.vue?vue&type=script&lang=js&"
export * from "./Text705.vue?vue&type=script&lang=js&"
import style0 from "./Text705.vue?vue&type=style&index=0&id=54647a08&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54647a08",
  null
  
)

export default component.exports